import { Pricelist } from "../../api/pricelist";
import type { CategoryNameResolver } from "../../utils/pricelistFormat";
import {
  getPricelistCheckTypeCategories,
  getPricelistCheckTypeLabels,
  getPricelistCheckTypeLimits,
  getPricelistCheckTypeOptions,
  getPricelistPaymentPeriods,
  getPricelistPrices,
  getPricelistStatusLabel,
  getPricelistVisibleForUsersLabel,
} from "../../utils/pricelistFormat";
import { PricelistTableCellLines } from "./PricelistTableCells";
import "../RequestTable/RequestTable.scss";

interface PricelistTableProps {
  data: Pricelist[];
  onRowClick: (id: string) => void;
  resolveCategoryName: CategoryNameResolver;
}

export const PricelistTable = ({
  data,
  onRowClick,
  resolveCategoryName,
}: PricelistTableProps) => (
  <div className="request-table-wrapper">
    <div className="request-table-card">
      <table className="request-table request-table--pricelist">
        <thead>
          <tr>
            <th>Статус</th>
            <th>Название</th>
            <th>Описание</th>
            <th>Видимость</th>
            <th>Стоимость</th>
            <th>Период оплаты</th>
            <th>Типы проверок</th>
            <th>Лимиты</th>
            <th>Категории</th>
            <th>Опции</th>
          </tr>
        </thead>
        <tbody>
          {data.length === 0 ? (
            <tr>
              <td colSpan={10} className="request-table-empty">
                Нет данных
              </td>
            </tr>
          ) : (
            data.map((item) => (
              <tr
                key={item.id}
                className="request-table-row-clickable"
                onClick={() => item.id && onRowClick(item.id)}
              >
                <td>
                  <span className="request-table-status">
                    {getPricelistStatusLabel(item.status)}
                  </span>
                </td>
                <td>{item.name?.trim() || "—"}</td>
                <td>{item.description?.trim() || "—"}</td>
                <td>{getPricelistVisibleForUsersLabel(item)}</td>
                <td>
                  <PricelistTableCellLines lines={getPricelistPrices(item)} />
                </td>
                <td>
                  <PricelistTableCellLines lines={getPricelistPaymentPeriods(item)} />
                </td>
                <td>
                  <PricelistTableCellLines lines={getPricelistCheckTypeLabels(item)} />
                </td>
                <td>
                  <PricelistTableCellLines lines={getPricelistCheckTypeLimits(item)} />
                </td>
                <td>
                  <PricelistTableCellLines
                    lines={getPricelistCheckTypeCategories(item, resolveCategoryName)}
                  />
                </td>
                <td>
                  <PricelistTableCellLines lines={getPricelistCheckTypeOptions(item)} />
                </td>
              </tr>
            ))
          )}
        </tbody>
      </table>
    </div>
  </div>
);
